const BlogLanding = {
  init: function () {
    if (!document.querySelector(".blog-listing--all") || !window.__blogs) return

    this.onArticle = 0
    this.getArticles()

    document
      .querySelector(".pagination .read-more")
      .addEventListener("click", (event) => {
        event.preventDefault()
        this.parseArticles()
      })
  },

  getArticles: function () {
    let articles = []
    window.__blogs.forEach((blog) => {
      blog.articles.forEach((article) => {
        articles.push(article)
      })
    })

    articles.sort((a, b) => {
      return parseInt(b.date) - parseInt(a.date); // Sort in descending order (newest first)
    });

    this.articles = articles
    this.parseArticles()
  },

  parseArticles: function () {
    const elListing = document.querySelector(".blog-listing--all")
    let howMany = this.onArticle == 0 ? 5 : 6
    let articles = this.articles
    articles = articles.slice(this.onArticle, this.onArticle + howMany)
    articles.forEach((article) => {
      const html = this.getArticleHtml(
        article,
        this.onArticle == 0 ? true : false
      )
      elListing.innerHTML += html
      this.onArticle++
    })

    if (articles.length < howMany) {
      document.querySelector(".pagination").remove()
    }
  },

  getArticleHtml: function (article, isFirst) {
    const imageUrl = isFirst
      ? article.image.replace(/(\.png|\.jpg|\.jpeg|\.webp)(\?.*)?$/, "_1600x$1$2")
      : article.image.replace(/(\.png|\.jpg|\.jpeg|\.webp)(\?.*)?$/, "_700x$1$2")

    let html = `
		<div class="blog ${isFirst ? "first" : ""}">
			<a href="${article.url}"><img src="${imageUrl}" alt="${
      article.title
    }" /></a>`
    
    if (isFirst) {
      html += `<h4><a href="${article.url}">${article.title}</a></h4><p class="large">${article.excerpt}</p>`
    } else {
      html += `<h5><a href="${article.url}">${article.title}</a></h5><p class="medium">${article.excerpt}</p>`
    }

    html += "</div>"

    return html
  },
}

export default BlogLanding
